type AuthEventCallback = () => void;

let logoutCallback: AuthEventCallback | null = null;

export const setLogoutCallback = (cb: AuthEventCallback) => {
  logoutCallback = cb;
};

export const triggerLogout = () => {
  if (logoutCallback) {
    logoutCallback();
  } else {
    // Fallback: React Router实例未就绪时使用硬跳转，正常流程下不会执行此分支，因App.tsx在mount时即注册回调
    window.location.href = '/login';
  }
};
